import { gql } from '@apollo/client';

export const DELETE_TOOL = gql`
  mutation DeleteTool($id: ID!) {
    deleteTool(input: { id: $id }) {
      tool {
        id
      }
      errors
    }
  }
`;
